var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_426_236",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 9
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 0H1.33333C0.596954 0 0 0.537258 0 1.2V7.8C0 8.46274 0.596954 9 1.33333 9H12.6667C13.403 9 14 8.46274 14 7.8V1.2C14 0.537258 13.403 0 12.6667 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_426_236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 0H1.33333C0.596954 0 0 0.537258 0 1.2V7.8C0 8.46274 0.596954 9 1.33333 9H12.6667C13.403 9 14 8.46274 14 7.8V1.2C14 0.537258 13.403 0 12.6667 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H6V4.2H0V0Z",
    fill: "#444379"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666672 0.600006V1.20001H1.33334V0.600006H0.666672ZM2.00001 0.600006V1.20001H2.66667V0.600006H2.00001ZM3.33334 0.600006V1.20001H4.00001V0.600006H3.33334ZM4.66667 0.600006V1.20001H5.33334V0.600006H4.66667ZM4.00001 1.20001V1.80001H4.66667V1.20001H4.00001ZM2.66667 1.20001V1.80001H3.33334V1.20001H2.66667ZM1.33334 1.20001V1.80001H2.00001V1.20001H1.33334ZM0.666672 1.80001V2.40001H1.33334V1.80001H0.666672ZM2.00001 1.80001V2.40001H2.66667V1.80001H2.00001ZM3.33334 1.80001V2.40001H4.00001V1.80001H3.33334ZM4.66667 1.80001V2.40001H5.33334V1.80001H4.66667ZM0.666672 3.00001V3.60001H1.33334V3.00001H0.666672ZM2.00001 3.00001V3.60001H2.66667V3.00001H2.00001ZM3.33334 3.00001V3.60001H4.00001V3.00001H3.33334ZM4.66667 3.00001V3.60001H5.33334V3.00001H4.66667ZM4.00001 2.40001V3.00001H4.66667V2.40001H4.00001ZM2.66667 2.40001V3.00001H3.33334V2.40001H2.66667ZM1.33334 2.40001V3.00001H2.00001V2.40001H1.33334Z",
    fill: "#A7B6E7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0V0.6H14V0H6ZM6 1.2V1.8H14V1.2H6ZM6 2.4V3H14V2.4H6ZM6 3.6V4.2H14V3.6H6ZM0 4.8V5.4H14V4.8H0ZM0 6V6.6H14V6H0ZM0 7.2V7.8H14V7.2H0ZM0 8.4V9H14V8.4H0Z",
    fill: "#ED4C49"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/US.e6450ccd541f4381914116631e4fc6db.svg";
export { ForwardRef as ReactComponent };